<template>
    <div>
        <div class="flex flex-wrap">
            <v-button icon="arrow-left" @click="goToPage('cost_budget')" color="grey" size="small" class="mr-8">
                {{ $t('back') }}
            </v-button>
        </div>
        <h1 class="flex-grow text-blue-light font-bold text-xl uppercase mt-4 mb-2">
            {{ $t('new') }} {{ type === 0 ? $t('indirect_costs') : $t('direct_costs') }}
        </h1>
        <div class="top-bar flex justify-start">
            <b-field :label="$t(type === 0 ? 'indirect_cost_name' : 'direct_cost_name')" class="w-full lg:w-1/4 mr-4">
                <b-input v-model="name" type="text" expanded></b-input>
            </b-field>
            <b-field :label="$t('code')" class="w-full lg:w-1/4 mr-4">
                <b-input v-model="code" type="text" expanded></b-input>
            </b-field>
            <b-field :label="$t('amount')" class="w-full lg:w-1/4 mr-4">
                <b-input v-model="price_total" type="number" expanded disabled></b-input>
            </b-field>
        </div>
        <div class="flex justify-end">
            <v-button @click="openCostModal" icon="plus">
                {{ $t(type === 0 ? 'add_indirect_cost' : 'add_direct_cost') }}
            </v-button>
        </div>
        <cost-detail-modal ref="cost_detail_modal" :projectId="projectId" :type="type" @reload-list="handleReload"
            @total-amount="handleTotalAmount" />
        <cost-details :projectId="projectId" :type="type" ref="details_table" @epc-edit="handleEditDetail"
            @reload-list="handleReload" @total-price="handleTotalAmount" @name-cost="handleNameCost" />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import CostDetailModal from "../../components/cost-management/cost/cost-detail/cost-detail-modal.vue";
import CostDetails from "../../components/cost-management/cost/cost-detail/cost-detail-table.vue";

export default {
    components: {
        CostDetailModal,
        CostDetails
    },
    data() {
        return {
            projectId: null,
            code: '',
            name: '',
            price_total: 0,
            details: [],
            cost: null,
            id: null,
            type:null
        };
    },
    computed: {
        isFormValid() {
            return this.name !== '' && this.code !== '';
        },
        ...mapGetters({
            navData: "app/navData"
        })
    },
    created () {
        this.projectId = this.navData.project_id;
        this.cost = this.$route.params.cost;
        this.type = Number(this.$route.params.type);
        if (this.cost) {
            this.name = this.cost.name || '';
            this.code = this.cost.code || '';
            this.price_total = this.cost.price_total || 0;
            this.id = this.cost.id || null;
        };
    },
    mounted() {
        this.handleReload();
    },
    methods: {
        handleReload(data = null) {
            const costCode = data ? data.id : this.id;
            this.$refs.details_table.reload({ cost_code: costCode });
        },
        
        async openCostModal(detail = null) {
            if (!this.isFormValid) {
                this.$toast.open({
                    message: this.$t('please_complete_required_fields'),
                    type: 'is-danger',
                    position: 'is-top-right'
                });
                return;
            }
            this.$refs.cost_detail_modal.show({ name: this.name, code: this.code, detail: detail });
        },
        handleEditDetail(detail) {
            this.openCostModal(detail);
        },
        handleTotalAmount(total) {
            this.price_total = total;
        },
        handleNameCost(name) {
            this.name = name;
        },
        goToPage(destiny) {
            switch (destiny) {
                case 'cost_budget':
                    this.$router.push({
                        name: 'project.admin.cost-management',
                        params: {
                            project_id: this.projectId
                        },
                        query: {
                            tab: this.type === 0 ? 'indirect-cost' : 'direct-cost'
                        }
                    });
                    break;
            }
        }
    },

};
</script>

<style lang="scss" scoped></style>